import CampaignIcon from '~icons/material-symbols-light/campaign-outline';
import NorthEastIcon from '~icons/material-symbols-light/north-east';
import ShieldWithHouseIcon from '~icons/material-symbols-light/shield-with-house-outline';
import TrophyIcon from '~icons/material-symbols-light/trophy-outline';

export default {
	pt: {
		hero: {
			title: 'Anunciar imóvel',
			description:
				'Cadastre seu imóvel no maior portfólio de alto padrão de São Paulo.'
		},
		breadcrumb: {
			home: 'Início',
			advertiseProperty: 'Anunciar imóvel'
		},
		benefits: [
			{
				icon: CampaignIcon,
				title: 'Ampla visibilidade',
				description: 'Seu imóvel alcança os compradores certos.'
			},
			{
				icon: TrophyIcon,
				title: 'Corretores especialistas',
				description:
					'Você terá o atendimento personalizado de um especialista na região de interesse.'
			},
			{
				icon: ShieldWithHouseIcon,
				title: 'Gratuito e seguro',
				description:
					'Anuncie sem pagar nada, com total segurança e tranquilidade.'
			}
		],
		content: {
			benefits: [
				{
					icon: CampaignIcon,
					title: 'Ampla visibilidade',
					description: 'Seu imóvel alcança os compradores certos.'
				},
				{
					icon: TrophyIcon,
					title: 'Corretores especialistas',
					description:
						'Você terá o atendimento personalizado de um especialista na região de interesse.'
				},
				{
					icon: ShieldWithHouseIcon,
					title: 'Gratuito e seguro',
					description:
						'Anuncie sem pagar nada, com total segurança e tranquilidade.'
				}
			],
			howItWorks: {
				title: 'Como funciona',
				list: [
					'Preencha as informações básicas do seu imóvel',
					'Informe seus dados para contato',
					'Receba o suporte de um corretor especialista no alto padrão',
					'Tenha o imóvel anunciado pelo seu corretor'
				]
			}
		},
		advertise: {
			title: 'Anuncie seu imóvel agora',
			description:
				'Preencha as informações básicas do seu imóvel e deixe nossos especialistas cuidarem do resto.'
		},
		faq: {
			title: 'Perguntas frequentes',
			questions: [
				{
					question: 'Como faço para anunciar um imóvel?',
					answer:
						'Para anunciar, clique em "Falar com especialista" e preencha o formulário com os detalhes do seu imóvel. Sua solicitação será então encaminhada a um corretor parceiro da Rede Pilar, que entrará em contato em breve para dar continuidade ao processo de publicação do seu imóvel no PilarHomes.'
				},
				{
					question: 'Como é selecionado o corretor que irá me atender?',
					answer:
						'Na Pilar, contamos com mais de 500 corretores especialistas em alto padrão, dedicados a oferecer o melhor atendimento para você e seus clientes. Ao preencher o formulário, usaremos os dados fornecidos para conectá-lo a um corretor parceiro da Rede Pilar de excelência, especializado na região e na faixa de valor do seu imóvel. Assim, garantimos que você contará com um especialista capacitado para valorizar e promover sua propriedade com o máximo de expertise.'
				},
				{
					question: 'O PilarHomes anuncia quais tipos de imóvel?',
					answer:
						'O PilarHomes é especializado em imóveis residenciais de alto padrão, acreditamos que ter foco é essencial para oferecer uma experiência completa e exclusiva para quem busca esse tipo de imóvel. Por isso, apenas anunciamos imóveis residenciais à venda, no estado de São Paulo e com valor superior a R$ 2 Milhões. '
				},
				{
					question:
						'Posso trabalhar um imóvel que não atende aos critérios do PilarHomes?',
					answer:
						'Sim. Embora seu imóvel não possa ser trabalhado diretamente no PilarHomes, você ainda pode trabalhá-lo na Rede Pilar. A Rede Pilar conecta você à melhor rede de corretores de alto padrão, garantindo máxima visibilidade para o seu imóvel. Nela, você contará com o suporte de um especialista em alto padrão de excelência, que garantirá que seu imóvel seja tratado com a expertise e atenção necessárias. Para iniciar, clique em "Falar com especialista" e preencha o formulário com os detalhes do seu imóvel. Sua solicitação será então encaminhada a um corretor parceiro da Rede Pilar, que entrará em contato em breve com você.'
				},
				{
					question: 'Como posso editar o meu anúncio?',
					answer:
						'Para editar seu anúncio, entre em contato com nosso Parceiro Pilar, seu ponto de contato direto no PilarHomes. Ele fará os ajustes necessários para garantir que seu anúncio esteja sempre atualizado e em destaque.'
				},
				{
					question: 'Quanto o PilarHomes cobra para vender?',
					answer:
						'O PilarHomes oferece uma solução sem custos extras para o vendedor. Nossa remuneração é paga pelo próprio corretor parceiro, e você, proprietário, fica responsável apenas pela taxa de corretagem com a concretização da venda, de até 6%.'
				}
			]
		},
		CTA: {
			advertiseMyProperty: {
				label: 'Anunciar meu imóvel',
				icon: NorthEastIcon
			}
		}
	}
};
